exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".paywallBlurbContainer{margin-top:10px}.paywallBlurbContainer .paywallText{display:inline-block}.paywallBlurbContainer .insightsPaywall{margin-bottom:25px}.paywallBlurbContainer .studentRosterPaywall{width:67%}.paywallBlurbContainer .paywallLinkButton{position:relative;bottom:15px;margin-left:25px}.paywallBlurbContainer .insightsPaywallBtn{margin-left:0}.paywallBlurbContainer .webinarRegistration{bottom:3rem}.studentRosterBlurb{position:relative;bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/teachers/paywall_link.scss
// module id = 1446
// module chunks = 0